import { useEffect, useState } from "react";
import { TimerDto, TournamentResponse } from "../../../api/tournament";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../recoil/pub.atom";
import {
  MoneyInChip,
  StructuresResponse,
} from "../../tournament/hook/useEditTournament";

export enum PosterTab {
  TEMPLATE = "TEMPLATE",
  COLOR = "COLOR",
  INFO = "INFO",
}

export enum PosterTemplateGrade {
  ALL = "ALL",
  STANDARD = "STANDARD",
  PREMIUM = "PREMIUM",
}

export enum PosterInfoType {
  MAIN = "MAIN",
  INFO = "INFO",
  NOTICE = "NOTICE",
  PRIZE_POOL = "PRIZE_POOL",
  STRUCTURE = "STRUCTURE",
  ADDRESS = "ADDRESS",
  IMAGE = "IMAGE",
}

export interface PosterPrizePool {
  isShow: boolean;
  rank: string;
  prize: string;
}

export interface PosterInfoDto {
  label: string;
  value: string;
  color?: string;
  isShow: boolean;
}

const usePoster = () => {
  const pub = useRecoilValue(pubState);
  // tab state
  const [tab, setTab] = useState<PosterTab>(PosterTab.TEMPLATE);
  const [templateGrade, setTemplateGrade] = useState<PosterTemplateGrade>(
    PosterTemplateGrade.ALL
  );
  const [infoType, setInfoType] = useState<PosterInfoType>(PosterInfoType.MAIN);

  // selected state
  const [selectedTemplate, setSelectedTemplate] = useState<number | null>(null);
  const [selectedTournament, setSelectedTournament] =
    useState<TournamentResponse | null>(null);

  // Util state
  const [isHideLine, setIsHideLine] = useState<boolean>(false);

  // poster data state
  // main info tab
  const [title, setTitle] = useState<PosterInfoDto>({
    label: "title",
    value: "",
    color: "#FFF ",
    isShow: true,
  });
  const [subTitle, setSubTitle] = useState<PosterInfoDto>({
    label: "subTitle",
    value: "",
    color: "#FFF",
    isShow: true,
  });
  const [startDate, setStartDate] = useState<PosterInfoDto>({
    label: "startDate",
    value: "",
    color: "#B5B5B7",
    isShow: true,
  });
  const [pubName, setPubName] = useState<PosterInfoDto>({
    label: "pubName",
    value: "",
    color: "#B7B6BD",
    isShow: true,
  });
  // info tab
  const [infoSection, setInfoSection] = useState<string>("INFORMATION");
  const [infoFontSize, setInfoFontSize] = useState<number>(9);
  const [tournamentType, setTournamentType] = useState<PosterInfoDto>({
    label: "TYPE",
    value: "",
    isShow: true,
  });
  const [registerLimitLevel, setRegisterLimitLevel] = useState<PosterInfoDto>({
    label: "REG CLOSE",
    value: "",
    isShow: true,
  });
  const [entry, setEntry] = useState<PosterInfoDto>({
    label: "ENTRY",
    value: "",
    isShow: true,
  });
  const [buyIn, setBuyIn] = useState<PosterInfoDto>({
    label: "BUY-IN",
    value: "",
    isShow: true,
  });
  const [startingStack, setStartingStack] = useState<PosterInfoDto>({
    label: "STARTING STACK",
    value: "",
    isShow: true,
  });
  const [reBuyIn, setReBuyIn] = useState<PosterInfoDto>({
    label: "RE-ENTRY",
    value: "",
    isShow: true,
  });
  const [reBuyInStack, setReBuyInStack] = useState<PosterInfoDto>({
    label: "RE-ENTRY STACK",
    value: "",
    isShow: true,
  });
  const [addOn, setAddOn] = useState<PosterInfoDto>({
    label: "ADD-ON",
    value: "",
    isShow: true,
  });
  const [addOnStack, setAddOnStack] = useState<PosterInfoDto>({
    label: "ADD-ON STACK",
    value: "",
    isShow: true,
  });
  const [duration, setDuration] = useState<PosterInfoDto>({
    label: "DURATION",
    value: "",
    isShow: true,
  });
  //notice tab
  const [noticeSection, setNoticeSection] = useState<string>("NOTICE");
  const [notice, setNotice] = useState<string>("");
  // prize pool tab
  const [prizePoolSection, setPrizePoolSection] =
    useState<string>("PRIZE POOL");
  const [prizePool, setPrizePool] = useState<PosterPrizePool[]>([]);
  const [prizePoolFontSize, setPrizePoolFontSize] = useState<number>(8);
  //structure tab
  const [structureSection, setStructureSection] =
    useState<string>("BLIND  STRUCTURE");
  const [showLevel, setShowLevel] = useState<boolean>(true);
  const [levelLabel, setLevelLabel] = useState<string>("LEVEL");
  const [showSmallBlind, setShowSmallBlind] = useState<boolean>(true);
  const [smallBlindLabel, setSmallBlindLabel] = useState<string>("SMALL");
  const [showBigBlind, setShowBigBlind] = useState<boolean>(true);
  const [bigBlindLabel, setBigBlindLabel] = useState<string>("BIG");
  const [showAnte, setShowAnte] = useState<boolean>(true);
  const [anteLabel, setAnteLabel] = useState<string>("ANTE");
  const [showDuration, setShowDuration] = useState<boolean>(true);
  const [durationLabel, setDurationLabel] = useState<string>("TIME ");
  const [blindStructure, setBlindStructure] = useState<StructuresResponse[]>(
    []
  );
  const [breakText, setBreakText] = useState<string>("BREAK");
  const [breakTime, setBreakTime] = useState<string>("MINS");
  //address tab
  const [showAddress, setShowAddress] = useState<boolean>(false);
  const [address, setAddress] = useState<string>("");

  //image tab
  const [topPadding, setTopPadding] = useState<number>(15);
  const [rightPadding, setRightPadding] = useState<number>(15);
  const [image1, setImage1] = useState<string>("");
  const [image2, setImage2] = useState<string>("");

  // background tab
  const [background, setBackground] = useState<string>("#1F1463");

  const getDuration = (timerDtos: StructuresResponse[]) => {
    // type이 "LEVEL"인 것만 필터링
    const levelTimes = timerDtos
      .filter((item) => item.type === "LEVEL")
      .map((item) => item.time);

    if (levelTimes.length === 0) return "";

    // 중복 제거 (순서 유지)
    const seen = new Set<number>();
    const uniqueTimes: number[] = [];

    for (const time of levelTimes) {
      if (!seen.has(time)) {
        seen.add(time);
        uniqueTimes.push(time);
      }
    }

    // "/"로 구분하여 문자열로 반환
    return uniqueTimes.join(" / ") + " MIN";
  };

  const convertPrizePool = (prizePool: MoneyInChip[]) => {
    const prizeWay = selectedTournament?.prizeWay;
    return prizePool.map((item) => ({
      isShow: true,
      rank:
        item.rank.toString() +
        (item.rank === 1
          ? "st"
          : item.rank === 2
          ? "nd"
          : item.rank === 3
          ? "rd"
          : "th"),
      prize: item.point.toString() + (prizeWay ? ` ${prizeWay}` : ""),
    }));
  };

  useEffect(() => {
    if (!selectedTournament) return;
    // main info tab
    setTitle({
      ...title,
      value: selectedTournament.title,
    });
    setSubTitle({
      ...subTitle,
      value: selectedTournament.subTitle,
    });
    setStartDate({
      ...startDate,
      value: convertStartDate(selectedTournament.startDate),
    });
    setPubName({
      ...pubName,
      value: pub?.pubName ?? "",
    });

    // info tab
    setTournamentType({
      ...tournamentType,
      value:
        selectedTournament.tournamentType === "TOURNAMENT" ? "GTD" : "DAILY",
    });
    setRegisterLimitLevel({
      ...registerLimitLevel,
      value: "LV " + selectedTournament.registerDeadlineLevel.toString(),
    });
    setEntry({
      ...entry,
      value: selectedTournament.entry?.toString() + " +",
    });
    setBuyIn({
      ...buyIn,
      value: selectedTournament.buyIn?.toLocaleString() ?? "",
    });
    setStartingStack({
      ...startingStack,
      value: selectedTournament.buyInChip?.toLocaleString() ?? "",
    });
    setReBuyIn({
      ...reBuyIn,
      value: selectedTournament.reBuyIn?.toLocaleString() ?? "",
    });
    setReBuyInStack({
      ...reBuyInStack,
      value: selectedTournament.reBuyInChip?.toLocaleString() ?? "",
    });
    setAddOn({
      ...addOn,
      value: selectedTournament.addOn?.toLocaleString() ?? "",
    });
    setAddOnStack({
      ...addOnStack,
      value: selectedTournament.adOnChip?.toLocaleString() ?? "",
    });
    setDuration({
      ...duration,
      value: getDuration(selectedTournament.structure),
    });

    // notice tab
    setNotice(selectedTournament.notice ?? "");

    // prize pool tab
    setPrizePool(convertPrizePool(selectedTournament.moneyInChip));

    // structure tab
    setBlindStructure(selectedTournament.structure);
  }, [selectedTournament]);

  useEffect(() => {
    if (!selectedTemplate) return;
    if (selectedTemplate === 1) {
      setPubName({
        ...pubName,
        color: "#fff",
      });
      setStartDate({
        ...startDate,
        color: "#fff",
      });
      setTitle({
        ...title,
        color: "#fff",
      });
      setSubTitle({
        ...subTitle,
        color: "#fff",
      });
      setPrizePoolFontSize(8);
    }
    if (selectedTemplate === 2) {
      setPubName({
        ...pubName,
        color: "#B7B6BD",
      });
      setStartDate({
        ...startDate,
        color: "#B5B5B7 ",
      });
      setTitle({
        ...title,
        color: "#fff",
      });
      setSubTitle({
        ...subTitle,
        color: "#fff",
      });
      setPrizePoolFontSize(16);
    }
    if (selectedTemplate === 3) {
      setPubName({
        ...pubName,
        color: "#B7B6BD",
      });
      setStartDate({
        ...startDate,
        color: "#B7B6BD",
      });
      setTitle({
        ...title,
        color: "#fff",
      });
      setSubTitle({
        ...subTitle,
        color: "#fff",
      });
      setPrizePoolFontSize(16);
    }
  }, [selectedTemplate]);

  const convertStartDate = (startDate: string) => {
    // YYYY-MM-DD(요일) HH:MMPM
    const date = new Date(startDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
    const weekday = weekdays[date.getDay()];

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // 0시는 12시로 표시
    const formattedHours = String(hours).padStart(2, "0");

    return `${year}-${month}-${day}(${weekday}) ${formattedHours}:${minutes}${ampm}`;
  };

  //초기화
  const handleReset = () => {
    // 선택한 템플릿과 토너먼트 초기화
    setSelectedTemplate(null);
    setSelectedTournament(null);
    // 템플릿 등급 초기화
    setTemplateGrade(PosterTemplateGrade.ALL);
    // 정보 타입 초기화
    setInfoType(PosterInfoType.MAIN);
    setTab(PosterTab.TEMPLATE);
    // Util state 초기화
    setIsHideLine(false);
    //메인 정보 탭 초기화
    setTitle({
      label: "title",
      value: "",
      color: "#FFF",
      isShow: true,
    });
    setSubTitle({
      label: "subTitle",
      value: "",
      color: "#FFF",
      isShow: true,
    });
    setStartDate({
      label: "startDate",
      value: "",
      color: "#B5B5B7",
      isShow: true,
    });
    setPubName({
      label: "pubName",
      value: "",
      color: "#B7B6BD",
      isShow: true,
    });
    setInfoSection("INFORMATION");
    setInfoFontSize(9);
    // 정보 탭 초기화
    setTournamentType({
      label: "TYPE",
      value: "",
      isShow: true,
    });
    setRegisterLimitLevel({
      label: "REG CLOSE",
      value: "",
      isShow: true,
    });
    setEntry({
      label: "ENTRY",
      value: "",
      isShow: true,
    });
    setBuyIn({
      label: "BUY-IN",
      value: "",
      isShow: true,
    });
    setStartingStack({
      label: "STARTING STACK",
      value: "",
      isShow: true,
    });
    setReBuyIn({
      label: "RE-ENTRY",
      value: "",
      isShow: true,
    });
    setReBuyInStack({
      label: "RE-ENTRY STACK",
      value: "",
      isShow: true,
    });
    setAddOn({
      label: "ADD-ON",
      value: "",
      isShow: true,
    });
    setAddOnStack({
      label: "ADD-ON STACK",
      value: "",
      isShow: true,
    });
    setDuration({
      label: "DURATION",
      value: "",
      isShow: true,
    });
    // notice tab
    setNoticeSection("NOTICE");
    setNotice("");
    // prize pool tab
    setPrizePoolSection("PRIZE POOL");
    setPrizePool([]);
    setPrizePoolFontSize(8);
    // structure tab
    setStructureSection("BLIND  STRUCTURE");
    setBlindStructure([]);
    setShowLevel(true);
    setLevelLabel("LEVEL");
    setShowSmallBlind(true);
    setSmallBlindLabel("SMALL");
    setShowBigBlind(true);
    setBigBlindLabel("BIG");
    setShowAnte(true);
    setAnteLabel("ANTE");
    setShowDuration(true);
    setDurationLabel("TIME");
    setBreakText("BREAK");
    setBreakTime("MINS");
    // address tab
    setShowAddress(true);
    setAddress("");
    // image tab
    setTopPadding(30);
    setRightPadding(30);
    setImage1("");
    setImage2("");
    // background tab
    setBackground("#1F1463");
  };

  return {
    // 탭 상태 관리
    tab,
    setTab,
    templateGrade,
    setTemplateGrade,
    infoType,
    setInfoType,
    // 선택한 상태값
    selectedTemplate,
    setSelectedTemplate,
    selectedTournament,
    setSelectedTournament,
    // Util state
    isHideLine,
    setIsHideLine,
    // poster data state
    // main info tab
    title,
    setTitle,
    subTitle,
    setSubTitle,
    startDate,
    setStartDate,
    pubName,
    setPubName,
    // info tab
    infoSection,
    setInfoSection,
    infoFontSize,
    setInfoFontSize,
    tournamentType,
    setTournamentType,
    registerLimitLevel,
    setRegisterLimitLevel,
    entry,
    setEntry,
    buyIn,
    setBuyIn,
    startingStack,
    setStartingStack,
    reBuyIn,
    setReBuyIn,
    reBuyInStack,
    setReBuyInStack,
    addOn,
    setAddOn,
    addOnStack,
    setAddOnStack,
    duration,
    setDuration,
    // notice tab
    noticeSection,
    setNoticeSection,
    notice,
    setNotice,
    // prize pool tab
    prizePoolSection,
    setPrizePoolSection,
    prizePool,
    setPrizePool,
    prizePoolFontSize,
    setPrizePoolFontSize,
    // structure tab
    structureSection,
    setStructureSection,
    blindStructure,
    setBlindStructure,
    showLevel,
    setShowLevel,
    levelLabel,
    setLevelLabel,
    showSmallBlind,
    setShowSmallBlind,
    smallBlindLabel,
    setSmallBlindLabel,
    showBigBlind,
    setShowBigBlind,
    bigBlindLabel,
    setBigBlindLabel,
    showAnte,
    setShowAnte,
    anteLabel,
    setAnteLabel,
    showDuration,
    setShowDuration,
    durationLabel,
    setDurationLabel,
    breakText,
    setBreakText,
    breakTime,
    setBreakTime,
    // address tab
    showAddress,
    setShowAddress,
    address,
    setAddress,
    // image tab
    topPadding,
    setTopPadding,
    rightPadding,
    setRightPadding,
    image1,
    setImage1,
    image2,
    setImage2,
    // background tab
    background,
    setBackground,
    // handle
    handleReset,
  };
};

export default usePoster;
